import * as yup from 'yup'

export const addSubSubjectsSchema = yup.object({
	name: yup.string().required(),
})
